<mat-dialog-content *ngIf="selectCycleDescriptionForm">
  <form [formGroup]="selectCycleDescriptionForm">
    <div>
      <mat-label><span style="color: red">*  </span>{{'ecase.admindashboard.competitions.awardFinalization.manage.cycle.seelctapprovalcycle' | translate}}</mat-label>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-select
          [attr.aria-label]="'ecase.admindashboard.competitions.awardFinalization.manage.cycle.seelctapprovalcycle'| eCaseTranslate"
          [formControlName]="'description'"
          id="ecase_competitions_competition_approval_levels_select_cycle">
          <mat-option [value]="">{{'ecase.common.pleaseSelect' | translate }}</mat-option>
          <mat-option *ngFor="let item of availableApprovalCycles" [value]="item.id">{{item.description}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="selectCycleDescriptionForm.get('description').errors?.required"> {{ 'ecase.admindashboard.competitions.awardFinalization.manage.cycle.thisFieldIsRequired.error' | translate }}</mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="eCase-dialog-action-button-align">
    <button mat-raised-button class="eCase-dialog-positive-action-button"
            [disabled]="selectCycleDescriptionForm.invalid " (click)="onConfirm()">
      {{'ecase.common.add' | translate}}</button>
    <button mat-raised-button class="eCase-dialog-negative-action-button" (click)="onClose()">{{'ecase.common.cancel' | translate}}</button>
  </div>
</mat-dialog-actions>
